// Central data for Dr. Cristian Santus site
// All content is Italian; all keys are English for developer clarity.

export const CONTACT = {
  name: "Dr. Cristian Santus",
  role: "Gastroenterologo",
  whatsapp: "3534924808",
  whatsappDisplay: "+39 353 492 4808",
  email: "santusgastroenterologo@gmail.com",
  miodottore: "https://www.miodottore.it/cristian-santus/gastroenterologo/cagliari",
};

export const IMAGES = {
  heroDoctor:
    "https://customer-assets-lqy194kg.emergentagent.net/job_elite-gastro-santus/artifacts/c5ag1fcc_ChatGPT%20Image%2012%20set%202026%2C%2011_42_01.png",
  aboutClinic:
    "https://images.pexels.com/photos/7789603/pexels-photo-7789603.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  consultation:
    "https://images.pexels.com/photos/7659874/pexels-photo-7659874.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  aboutDoctor:
    "https://customer-assets.emergentagent.com/job_elite-gastro-santus/artifacts/fwop9lov_Foto_Profilo_Lavoro.png",
  ctaBg:
    "https://images.pexels.com/photos/4173251/pexels-photo-4173251.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1600",
};

export const SERVICE_IMAGES = {
  "visita-gastroenterologica":
    "https://images.pexels.com/photos/7579834/pexels-photo-7579834.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  "follow-up":
    "https://images.pexels.com/photos/7579831/pexels-photo-7579831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  "second-opinion":
    "https://images.pexels.com/photos/7579828/pexels-photo-7579828.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  "consulenza-nutrizionale":
    "https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  "visita-domiciliare":
    "https://images.pexels.com/photos/7579832/pexels-photo-7579832.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
};

export const NUTRIZIONE_TESTIMONIALS = [
  {
    text: "Il Dottor Santus mi ha accompagnato in un percorso di dieta FODMAP per il mio colon irritabile. Finalmente ho ritrovato serenità a tavola, con un piano realistico e sostenibile.",
    author: "Martina S.",
    city: "Carbonia",
  },
  {
    text: "Dopo anni di gonfiore e stanchezza, con la dieta che mi ha preparato ho notato risultati concreti già nelle prime settimane. Spiegazioni chiarissime e grande disponibilità.",
    author: "Luca M.",
    city: "Portoscuso",
  },
  {
    text: "Diagnosi di celiachia e un piano nutrizionale cucito su misura, che tiene conto della mia vita da mamma lavoratrice. Un professionista empatico e preparato.",
    author: "Giulia P.",
    city: "Iglesias",
  },
  {
    text: "Avevo bisogno di un'indicazione precisa per la sindrome metabolica. Mi ha dato una dieta mediterranea personalizzata e il contatto WhatsApp è stato preziosissimo.",
    author: "Alessandro R.",
    city: "Sant'Antioco",
  },
  {
    text: "Finalmente un medico che ascolta davvero. La dieta per la diverticolosi era semplice da seguire e, cosa fondamentale, gustosa. Consigliatissimo.",
    author: "Simona L.",
    city: "Calasetta",
  },
  {
    text: "Ho scelto il pacchetto Premium e il follow-up su WhatsApp è stato oro: mi ha seguito passo passo, modulando la dieta sulle mie reali difficoltà.",
    author: "Federico B.",
    city: "Carloforte",
  },
  {
    text: "Approccio scientifico ma umano. Dopo la visita medico-nutrizionale ho perso peso senza sacrifici impossibili e con risultati stabili nel tempo.",
    author: "Chiara D.",
    city: "Gonnesa",
  },
  {
    text: "Trattati con rispetto e attenzione, mi ha ridato fiducia nella possibilità di gestire il diabete anche con una dieta che non fosse un sacrificio continuo.",
    author: "Marco T.",
    city: "San Giovanni Suergiu",
  },
];

export const NUTRIZIONE_INFO = {
  tagline: "Diete sartoriali per ogni paziente",
  intro:
    "Ogni dieta è costruita come un abito su misura: valuto la storia clinica, le abitudini alimentari, la vita quotidiana e le preferenze del paziente. Non diete standard: percorsi personalizzati, sostenibili nel tempo, basati sull'evidenza scientifica.",
  startDate: "Da novembre 2026",
  heroImage:
    "https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  secondaryImage:
    "https://images.pexels.com/photos/1435904/pexels-photo-1435904.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
};

export const NUTRIZIONE_PACKAGES = [
  {
    slug: "visita-medico-nutrizionale-standard",
    name: "Visita medico-nutrizionale",
    tier: "Standard",
    price: 220,
    icon: "Stethoscope",
    tagline: "Visita gastroenterologica + percorso nutrizionale",
    features: [
      "Visita gastroenterologica completa",
      "Valutazione nutrizionale (peso, altezza, BMI)",
      "Dieta specifica per patologia consegnata entro 7 giorni",
      "1 contatto email di follow-up a 2–4 settimane",
    ],
    patologie:
      "Indicata per anemia, celiachia, cardiopatia, diabete, dislipidemie, diverticolosi, pancreatite cronica, sindrome metabolica, stipsi e altre condizioni",
    featured: false,
  },
  {
    slug: "visita-medico-nutrizionale-premium",
    name: "Visita medico-nutrizionale",
    tier: "Premium",
    price: 280,
    icon: "Sparkles",
    tagline: "Percorso completo con assistenza prioritaria",
    features: [
      "Visita gastroenterologica completa",
      "Valutazione nutrizionale (peso, altezza, BMI)",
      "Dieta specifica per patologia entro 48–72 ore",
      "1 contatto WhatsApp dedicato di follow-up",
    ],
    patologie:
      "Indicata per anemia, celiachia, cardiopatia, diabete, dislipidemie, diverticolosi, pancreatite cronica, sindrome metabolica, stipsi e altre condizioni",
    featured: true,
  },
  {
    slug: "visita-nutrizionale-controllo",
    name: "Visita nutrizionale di controllo",
    tier: "Follow-up",
    price: 180,
    icon: "ClipboardList",
    tagline: "Per pazienti già visitati",
    features: [
      "Analisi nutrizionale (peso, altezza, BMI)",
      "Dieta specifica per patologia consegnata entro 7 giorni",
      "1 contatto email di follow-up a 4 settimane",
    ],
    note: "Riservata a pazienti già sottoposti a visita gastroenterologica",
    patologie:
      "Indicata per anemia, celiachia, cardiopatia, diabete, dislipidemie, diverticolosi, pancreatite cronica, sindrome metabolica, stipsi e altre condizioni",
    featured: false,
  },
  {
    slug: "dieta-colon-irritabile-standard",
    name: "Dieta per Colon Irritabile",
    tier: "Standard",
    price: 180,
    icon: "Leaf",
    tagline: "Protocollo low-FODMAP",
    features: [
      "Analisi nutrizionale (peso, altezza, BMI)",
      "Dieta a basso contenuto di FODMAP entro 48–72 ore",
      "1 contatto email di follow-up a 4 settimane",
    ],
    note: "Riservata a pazienti già sottoposti a visita gastroenterologica",
    featured: false,
  },
  {
    slug: "dieta-colon-irritabile-premium",
    name: "Dieta per Colon Irritabile",
    tier: "Premium",
    price: 240,
    icon: "Leaf",
    tagline: "Protocollo low-FODMAP con WhatsApp dedicato",
    features: [
      "Analisi nutrizionale (peso, altezza, BMI)",
      "Dieta a basso contenuto di FODMAP entro 24 ore",
      "1 contatto WhatsApp dedicato di follow-up",
    ],
    note: "Riservata a pazienti già sottoposti a visita gastroenterologica",
    featured: true,
  },
];

export const PATOLOGIE = [
  { slug: "reflusso-gastroesofageo", name: "Reflusso gastroesofageo", icon: "Flame" },
  { slug: "gastrite", name: "Gastrite", icon: "CircleAlert" },
  { slug: "helicobacter-pylori", name: "Helicobacter pylori", icon: "Bug" },
  { slug: "colon-irritabile", name: "Colon irritabile", icon: "Waves" },
  { slug: "stipsi", name: "Stipsi", icon: "TimerReset" },
  { slug: "diarrea-cronica", name: "Diarrea cronica", icon: "Droplets" },
  { slug: "celiachia", name: "Celiachia", icon: "Wheat" },
  { slug: "intolleranze-alimentari", name: "Intolleranze alimentari", icon: "Apple" },
  { slug: "malattie-infiammatorie-intestinali", name: "Malattie infiammatorie intestinali", icon: "Activity" },
  { slug: "polipi-del-colon", name: "Polipi del colon", icon: "CircleDot" },
  { slug: "sangue-nelle-feci", name: "Sangue nelle feci", icon: "AlertTriangle" },
  { slug: "dolore-addominale", name: "Dolore addominale", icon: "Zap" },
  { slug: "diverticolosi", name: "Diverticolosi", icon: "Grid3x3" },
  { slug: "meteorismo", name: "Meteorismo", icon: "Wind" },
  { slug: "dispepsia", name: "Dispepsia", icon: "CircleSlash" },
  { slug: "fegato-grasso", name: "Fegato grasso", icon: "Leaf" },
  { slug: "pancreatite", name: "Pancreatite", icon: "Flame" },
  { slug: "calprotectina-elevata", name: "Calprotectina elevata", icon: "TestTube" },
];

export const PRESTAZIONI = [
  {
    slug: "visita-gastroenterologica",
    name: "Visita gastroenterologica",
    duration: "30 minuti",
    desc: "Anamnesi approfondita, esame obiettivo e piano diagnostico-terapeutico personalizzato.",
    icon: "Stethoscope",
  },
  {
    slug: "second-opinion",
    name: "Second Opinion",
    duration: "Consulenza specialistica",
    desc: "Revisione dei referti, degli esami eseguiti e ridefinizione del percorso di cura.",
    icon: "FileSearch",
  },
  {
    slug: "follow-up",
    name: "Visita di follow-up",
    duration: "30 minuti",
    desc: "Monitoraggio nel tempo dei pazienti con patologie croniche o in terapia.",
    icon: "Repeat",
  },
  {
    slug: "consulenza-nutrizionale",
    name: "Consulenza dietetico-nutrizionale",
    duration: "Personalizzata",
    desc: "Indicazioni alimentari mirate per reflusso, colon irritabile, celiachia e intolleranze.",
    icon: "Apple",
  },
  {
    slug: "visita-domiciliare",
    name: "Visita gastroenterologica domiciliare",
    duration: "Su richiesta · a domicilio",
    desc: "Visita specialistica comodamente a casa, per pazienti fragili, anziani o con difficoltà di spostamento.",
    icon: "Home",
  },
];

export const TIMELINE = [
  {
    title: "Raccolta della storia clinica",
    desc: "Ascolto attento dei sintomi, delle abitudini e degli esami precedenti.",
  },
  {
    title: "Visita specialistica",
    desc: "Esame obiettivo mirato e valutazione clinica accurata.",
  },
  {
    title: "Diagnosi e referti",
    desc: "Interpretazione degli esami e comunicazione chiara della diagnosi.",
  },
  {
    title: "Piano terapeutico personalizzato",
    desc: "Terapia su misura, con follow-up e supporto continuo.",
  },
];

export const REVIEWS = [
  {
    text: "Professionale, preparato e molto disponibile. Ha saputo mettermi a mio agio dal primo momento.",
    author: "Maria G.",
    city: "Cagliari",
  },
  {
    text: "Mi sono sentita ascoltata fin dal primo momento. Un medico attento e umano.",
    author: "Laura T.",
    city: "Portoscuso",
  },
  {
    text: "Finalmente ho trovato un gastroenterologo che spiega tutto con chiarezza.",
    author: "Giovanni P.",
    city: "Carbonia",
  },
  {
    text: "Diagnosi rapida e precisa. Dopo anni ho trovato risposte concrete.",
    author: "Simona L.",
    city: "Iglesias",
  },
];

export const LOCATIONS = [
  {
    city: "Portoscuso",
    address: "Via Giulio Cesare, 63 — Portoscuso (SU)",
    maps: "https://www.google.com/maps/search/?api=1&query=Via+Giulio+Cesare+63+Portoscuso",
    note: "Sud Sardegna",
  },
  {
    city: "Carloforte",
    address:
      "Via Giuseppe Garibaldi, 98 — Studio Benessere e Nutrizione, Carloforte (SU)",
    maps: "https://www.google.com/maps/search/?api=1&query=Via+Giuseppe+Garibaldi+98+Carloforte",
    note: "Isola di San Pietro",
    badge: "Novità",
    openDate: "Dal 7 novembre 2026 · Prenotazioni aperte",
  },
  {
    city: "Sestu",
    address: "Via Monserrato, 144 — Polistudio Cau, Sestu (CA)",
    maps: "https://www.google.com/maps/search/?api=1&query=Via+Monserrato+144+Sestu+Polistudio+Cau",
    note: "Hinterland di Cagliari",
  },
  {
    city: "Cagliari",
    address:
      "Via Guido Cavalcanti, 11 — Centro Polispecialistico San Benedetto, Cagliari",
    maps: "https://www.google.com/maps/search/?api=1&query=Via+Guido+Cavalcanti+11+Cagliari+Centro+San+Benedetto",
    note: "Presso Centro Polispecialistico San Benedetto",
  },
];

export const FAQ = [
  {
    q: "Serve la richiesta del medico curante?",
    a: "Per la visita specialistica privata non è indispensabile la richiesta del medico curante. È comunque utile portare eventuali referti o terapie in corso.",
  },
  {
    q: "Come devo prepararmi alla visita?",
    a: "Porti con sé documento d'identità, tessera sanitaria, referti di esami precedenti (esami del sangue, ecografie, endoscopie) e l'elenco dei farmaci assunti.",
  },
  {
    q: "Quanto dura la visita gastroenterologica?",
    a: "Circa 30 minuti. Il tempo necessario per una raccolta accurata dei sintomi, un esame obiettivo completo e una discussione approfondita del piano terapeutico.",
  },
  {
    q: "Sono accettate le assicurazioni sanitarie?",
    a: "Sì, sono convenzionato con le principali compagnie assicurative. La invito a contattarci per verificare la copertura del suo piano.",
  },
  {
    q: "Quando è indicato eseguire una gastroscopia?",
    a: "In presenza di reflusso persistente, dolore epigastrico, difficoltà nella deglutizione, anemia sideropenica, calo di peso o storia familiare di neoplasie gastriche. Non eseguo direttamente l'esame endoscopico ma la indirizzo verso strutture e colleghi di fiducia, coordinando poi il percorso diagnostico-terapeutico.",
  },
  {
    q: "Quando è indicato eseguire una colonscopia?",
    a: "Come screening dopo i 50 anni (o prima se ci sono familiarità), in caso di sangue nelle feci, cambio dell'alvo, dolore addominale persistente o calprotectina elevata. Non eseguo personalmente l'esame ma la indirizzo a centri qualificati, gestendo l'interpretazione dei referti e il piano di cura.",
  },
];

export const WHY_CHOOSE = [
  {
    icon: "GraduationCap",
    title: "Specialista Gastroenterologo",
    desc: "Diagnosi e trattamento delle principali patologie digestive, con approccio basato sulle evidenze.",
  },
  {
    icon: "Building2",
    title: "Esperienza ospedaliera e privata",
    desc: "Un percorso clinico completo che unisce la profondità dell'ospedale alla cura del privato.",
  },
  {
    icon: "Heart",
    title: "Approccio umano",
    desc: "Ogni paziente viene seguito con attenzione, chiarezza e disponibilità.",
  },
];

export const ONORARI = [
  {
    name: "Prima visita gastroenterologica",
    price: 120,
    bollo: 2,
    duration: "30 minuti",
    desc: "Anamnesi approfondita, esame obiettivo e piano diagnostico-terapeutico personalizzato.",
    featured: true,
  },
  {
    name: "Visita di controllo",
    price: 85,
    bollo: 2,
    duration: "Follow-up",
    desc: "Monitoraggio delle patologie note e rivalutazione della terapia in corso.",
    featured: false,
  },
  {
    name: "Visita a domicilio",
    price: 180,
    bollo: 2,
    duration: "Su richiesta",
    desc: "Visita specialistica a casa del paziente, per chi ha difficoltà di spostamento.",
    featured: false,
  },
];

// SEO / condition pages content
export const CONDITION_CONTENT = {
  "reflusso-gastroesofageo": {
    title: "Reflusso gastroesofageo",
    subtitle: "Diagnosi e trattamento della malattia da reflusso",
    intro:
      "Il reflusso gastroesofageo è una delle condizioni più diffuse dell'apparato digerente. Un approccio corretto permette di controllare i sintomi ed evitare complicanze come esofagite, stenosi ed esofago di Barrett.",
    sections: [
      {
        h: "Sintomi principali",
        p: "Bruciore retrosternale, rigurgito acido, tosse cronica, raucedine mattutina, dolore toracico non cardiaco, sensazione di bolo faringeo.",
      },
      {
        h: "Cosa faccio in visita",
        p: "Valutazione clinica accurata, individuazione dei fattori scatenanti (dieta, peso, farmaci) e, quando indicato, indicazione a gastroscopia e pH-impedenziometria.",
      },
      {
        h: "Terapia",
        p: "Modifiche dello stile di vita, terapia farmacologica personalizzata (IPP, alginati, procinetici) e valutazione chirurgica solo in casi selezionati.",
      },
    ],
  },
  gastroscopia: {
    title: "Gastroscopia",
    subtitle: "Quando è indicata e come prepararsi",
    intro:
      "La gastroscopia è un esame endoscopico che consente lo studio diretto di esofago, stomaco e duodeno. Non eseguo direttamente l'esame ma valuto la corretta indicazione clinica, indirizzo a centri di fiducia e coordino l'intero percorso diagnostico-terapeutico.",
    sections: [
      {
        h: "Quando è indicata",
        p: "Reflusso persistente, dispepsia, dolore epigastrico, anemia sideropenica, difficoltà nella deglutizione, sospetto di Helicobacter pylori, screening in familiari di primo grado con neoplasie gastriche.",
      },
      {
        h: "Il mio ruolo",
        p: "Definisco l'indicazione, imposto la richiesta corretta, seleziono il centro più adeguato e leggo insieme al paziente il referto, integrandolo nel piano di cura.",
      },
      {
        h: "Preparazione generica",
        p: "Digiuno da almeno 8 ore. I dettagli sono forniti dal centro esecutore. In visita valutiamo insieme la sospensione di eventuali farmaci.",
      },
    ],
  },
  colonscopia: {
    title: "Colonscopia",
    subtitle: "Quando è indicata e come prepararsi",
    intro:
      "La colonscopia è lo strumento più efficace per la prevenzione del tumore del colon-retto. Non eseguo personalmente l'esame ma valuto l'indicazione, indirizzo a strutture qualificate e gestisco l'interpretazione dei referti nel percorso complessivo.",
    sections: [
      {
        h: "Quando è indicata",
        p: "Screening dopo i 50 anni, sangue nelle feci, cambio dell'alvo persistente, calprotectina elevata, familiarità per polipi o neoplasie del colon.",
      },
      {
        h: "Il mio ruolo",
        p: "Valuto sintomi e fattori di rischio, formulo la richiesta appropriata, ti aiuto a scegliere il centro e discuto con te il referto e le eventuali biopsie.",
      },
      {
        h: "Preparazione generica",
        p: "Preparazione intestinale specifica secondo protocollo del centro esecutore. In visita definiamo tempistiche e dettagli.",
      },
    ],
  },
  "colon-irritabile": {
    title: "Sindrome del colon irritabile",
    subtitle: "Un approccio integrato ai disturbi funzionali",
    intro:
      "La sindrome dell'intestino irritabile (IBS) è un disturbo cronico caratterizzato da dolore addominale associato ad alterazioni dell'alvo. Richiede un percorso diagnostico e terapeutico personalizzato.",
    sections: [
      {
        h: "Sintomi",
        p: "Dolore o discomfort addominale, gonfiore, alterazioni dell'alvo (stipsi, diarrea o forme miste), evacuazione incompleta.",
      },
      {
        h: "Diagnosi",
        p: "Diagnosi clinica basata sui criteri di Roma IV, con esclusione delle patologie organiche tramite esami mirati (calprotectina, breath test, endoscopia quando indicata).",
      },
      {
        h: "Terapia",
        p: "Approccio multidisciplinare: dieta low-FODMAP, terapia farmacologica sintomatica, gestione dello stress e supporto continuativo.",
      },
    ],
  },
  celiachia: {
    title: "Celiachia",
    subtitle: "Diagnosi e gestione della malattia celiaca",
    intro:
      "La celiachia è una malattia autoimmune scatenata dal glutine. Una diagnosi precoce e una corretta gestione permettono una vita normale e prevengono le complicanze.",
    sections: [
      {
        h: "Sintomi",
        p: "Diarrea cronica, dimagrimento, gonfiore addominale, anemia sideropenica, dermatite erpetiforme, sintomi neurologici.",
      },
      {
        h: "Diagnosi",
        p: "Esami sierologici (anti-transglutaminasi, EMA) seguiti da gastroscopia con biopsie duodenali per la conferma istologica.",
      },
      {
        h: "Gestione",
        p: "Dieta rigorosamente senza glutine a vita, con controlli periodici clinici e laboratoristici.",
      },
    ],
  },
  "helicobacter-pylori": {
    title: "Helicobacter pylori",
    subtitle: "Diagnosi ed eradicazione dell'infezione",
    intro:
      "L'Helicobacter pylori è un batterio che infetta lo stomaco ed è responsabile di gastrite, ulcera peptica e aumento del rischio di neoplasia gastrica.",
    sections: [
      {
        h: "Come si diagnostica",
        p: "Breath test all'urea 13C, ricerca dell'antigene fecale o biopsie gastriche durante gastroscopia.",
      },
      {
        h: "Quando trattarlo",
        p: "Sempre in caso di ulcera peptica, gastrite cronica atrofica, linfoma MALT, familiarità per carcinoma gastrico o dispepsia persistente.",
      },
      {
        h: "Terapia",
        p: "Terapia eradicante di 10–14 giorni con schema personalizzato in base alle resistenze locali, seguita da verifica dell'eradicazione.",
      },
    ],
  },
  gastrite: {
    title: "Gastrite",
    subtitle: "Infiammazione della mucosa gastrica",
    intro:
      "La gastrite è un'infiammazione della mucosa dello stomaco che può manifestarsi in forma acuta o cronica. Le cause più frequenti sono l'infezione da Helicobacter pylori, l'uso di FANS e lo stress.",
    sections: [
      {
        h: "Sintomi",
        p: "Bruciore epigastrico, dolore allo stomaco, nausea, senso di pienezza post-prandiale, digestione difficoltosa.",
      },
      {
        h: "Diagnosi",
        p: "Anamnesi accurata, ricerca dell'Helicobacter pylori (breath test o antigene fecale) e, quando indicato, gastroscopia con biopsie.",
      },
      {
        h: "Terapia",
        p: "Correzione dello stile di vita e della dieta, terapia gastroprotettiva (IPP), eradicazione dell'Helicobacter pylori quando presente.",
      },
    ],
  },
  stipsi: {
    title: "Stipsi",
    subtitle: "Diagnosi e gestione della stitichezza cronica",
    intro:
      "La stipsi cronica è un disturbo molto diffuso caratterizzato da evacuazione difficoltosa, poco frequente o incompleta. Un approccio corretto migliora nettamente la qualità di vita.",
    sections: [
      {
        h: "Cause principali",
        p: "Alimentazione povera di fibre, scarsa idratazione, sedentarietà, farmaci, disfunzioni del pavimento pelvico, patologie endocrine o neurologiche.",
      },
      {
        h: "Diagnosi",
        p: "Valutazione clinica, esami del sangue mirati e, in casi selezionati, studio funzionale del pavimento pelvico o colonscopia.",
      },
      {
        h: "Terapia",
        p: "Modifiche dietetiche, corretta idratazione, attività fisica, terapie farmacologiche graduate e riabilitazione del pavimento pelvico quando necessaria.",
      },
    ],
  },
  "diarrea-cronica": {
    title: "Diarrea cronica",
    subtitle: "Un percorso diagnostico ragionato",
    intro:
      "Per diarrea cronica si intende un'alterazione dell'alvo che persiste per oltre 4 settimane. Le cause sono molteplici e richiedono un percorso diagnostico strutturato.",
    sections: [
      {
        h: "Cause frequenti",
        p: "Sindrome dell'intestino irritabile, celiachia, intolleranze alimentari, malattie infiammatorie intestinali, infezioni, malassorbimento, farmaci.",
      },
      {
        h: "Esami utili",
        p: "Calprotectina fecale, esami del sangue, sierologia per celiachia, breath test, colonscopia quando indicata.",
      },
      {
        h: "Approccio",
        p: "Diagnosi mirata seguita da terapia specifica per la causa individuata: dieta, farmaci, gestione delle patologie sottostanti.",
      },
    ],
  },
  "intolleranze-alimentari": {
    title: "Intolleranze alimentari",
    subtitle: "Individuare i cibi che creano disturbi",
    intro:
      "Le intolleranze alimentari sono reazioni non allergiche a specifici alimenti. Le più frequenti sono al lattosio, al fruttosio e al glutine (celiachia).",
    sections: [
      {
        h: "Sintomi tipici",
        p: "Gonfiore, dolore addominale, meteorismo, diarrea o stipsi dopo l'assunzione di determinati alimenti.",
      },
      {
        h: "Come si diagnosticano",
        p: "Breath test specifici (lattosio, fruttosio), esclusione della celiachia con test sierologici, dieta di eliminazione e reintroduzione controllata.",
      },
      {
        h: "Gestione",
        p: "Piano dietetico personalizzato, con esclusione mirata e possibile reintroduzione progressiva sotto controllo specialistico.",
      },
    ],
  },
  "malattie-infiammatorie-intestinali": {
    title: "Malattie infiammatorie intestinali",
    subtitle: "Morbo di Crohn e rettocolite ulcerosa",
    intro:
      "Le malattie infiammatorie croniche intestinali (IBD) — morbo di Crohn e rettocolite ulcerosa — richiedono una diagnosi precoce e un percorso di cura specialistico continuativo.",
    sections: [
      {
        h: "Sintomi",
        p: "Diarrea persistente, sangue nelle feci, dolore addominale, dimagrimento, febbricola, manifestazioni extra-intestinali (articolari, cutanee).",
      },
      {
        h: "Diagnosi",
        p: "Calprotectina fecale, esami del sangue, colonscopia con biopsie, imaging (RM enterografia) quando indicato.",
      },
      {
        h: "Percorso di cura",
        p: "Terapia farmacologica personalizzata (mesalazina, immunomodulatori, biologici), follow-up regolare e coordinamento con centri di riferimento.",
      },
    ],
  },
  "polipi-del-colon": {
    title: "Polipi del colon",
    subtitle: "Prevenzione del tumore del colon-retto",
    intro:
      "I polipi del colon sono escrescenze della mucosa che, se non rimosse, possono evolvere in tumore. La colonscopia è lo strumento chiave di prevenzione.",
    sections: [
      {
        h: "Fattori di rischio",
        p: "Età superiore ai 50 anni, familiarità per polipi o carcinoma del colon, alimentazione povera di fibre, fumo, obesità.",
      },
      {
        h: "Screening",
        p: "Colonscopia di screening dopo i 50 anni (o prima in caso di familiarità), test del sangue occulto fecale, rimozione endoscopica di ogni polipo individuato.",
      },
      {
        h: "Follow-up",
        p: "Programmi di sorveglianza personalizzati in base al numero, tipo istologico e dimensione dei polipi rimossi.",
      },
    ],
  },
  "sangue-nelle-feci": {
    title: "Sangue nelle feci",
    subtitle: "Un sintomo che va sempre valutato",
    intro:
      "La presenza di sangue nelle feci è un sintomo che richiede sempre una valutazione specialistica per identificarne la causa: da emorroidi e ragadi fino a patologie più significative.",
    sections: [
      {
        h: "Cause possibili",
        p: "Emorroidi, ragadi anali, diverticolosi, malattie infiammatorie intestinali, polipi e — meno frequentemente — neoplasie.",
      },
      {
        h: "Diagnosi",
        p: "Esame proctologico, esami del sangue con emocromo e sideremia, calprotectina fecale, colonscopia in caso di indicazione clinica.",
      },
      {
        h: "Percorso",
        p: "Diagnosi mirata e trattamento specifico per la causa, con particolare attenzione all'esclusione di patologie neoplastiche.",
      },
    ],
  },
  "dolore-addominale": {
    title: "Dolore addominale",
    subtitle: "Individuare la causa per curare il sintomo",
    intro:
      "Il dolore addominale cronico o ricorrente è uno dei motivi più frequenti di consulto gastroenterologico. Un approccio sistematico permette di individuare la causa e impostare la terapia più efficace.",
    sections: [
      {
        h: "Possibili cause",
        p: "Colon irritabile, dispepsia funzionale, malattie infiammatorie, calcolosi biliare, gastrite, ulcera peptica, diverticolite.",
      },
      {
        h: "Valutazione",
        p: "Anamnesi accurata, esame obiettivo, esami mirati (ecografia addominale, esami ematici, endoscopia quando indicata).",
      },
      {
        h: "Terapia",
        p: "Trattamento specifico della causa sottostante, con approccio integrato tra dieta, farmaci e — quando necessario — supporto psicologico.",
      },
    ],
  },
  diverticolosi: {
    title: "Diverticolosi",
    subtitle: "Diagnosi e gestione dei diverticoli",
    intro:
      "La diverticolosi è una condizione molto comune dopo i 50 anni, caratterizzata dalla presenza di piccole estroflessioni della parete del colon. Nella maggior parte dei casi è asintomatica.",
    sections: [
      {
        h: "Sintomi",
        p: "Spesso asintomatica; possibili dolore addominale, alterazioni dell'alvo, gonfiore. Le forme complicate (diverticolite) causano dolore acuto e febbre.",
      },
      {
        h: "Diagnosi",
        p: "Colonscopia o TC addominale. La colonscopia consente inoltre lo screening di eventuali polipi associati.",
      },
      {
        h: "Gestione",
        p: "Dieta ricca di fibre, idratazione adeguata, terapia specifica in caso di diverticolite acuta, controlli periodici quando indicati.",
      },
    ],
  },
  meteorismo: {
    title: "Meteorismo",
    subtitle: "Eccesso di gas intestinale",
    intro:
      "Il meteorismo — l'eccessiva presenza di gas nell'intestino — è un disturbo molto diffuso che spesso condiziona la vita quotidiana e sociale del paziente.",
    sections: [
      {
        h: "Cause principali",
        p: "Sindrome dell'intestino irritabile, intolleranze alimentari, SIBO (sovracrescita batterica), alimentazione ricca di FODMAP, aerofagia.",
      },
      {
        h: "Diagnosi",
        p: "Anamnesi mirata, breath test (lattosio, glucosio, lattulosio per SIBO), esclusione della celiachia.",
      },
      {
        h: "Approccio",
        p: "Piano dietetico personalizzato (spesso low-FODMAP), correzione delle abitudini, terapia specifica quando necessaria.",
      },
    ],
  },
  dispepsia: {
    title: "Dispepsia",
    subtitle: "Cattiva digestione: cause e rimedi",
    intro:
      "La dispepsia è un insieme di sintomi legati alla parte alta dell'apparato digerente: dolore epigastrico, senso di pienezza, sazietà precoce. Può essere funzionale o secondaria a patologie specifiche.",
    sections: [
      {
        h: "Sintomi",
        p: "Dolore o bruciore epigastrico, sazietà precoce, senso di pienezza post-prandiale, nausea, digestione difficoltosa.",
      },
      {
        h: "Diagnosi",
        p: "Ricerca dell'Helicobacter pylori, gastroscopia in presenza di sintomi di allarme (età, calo di peso, anemia, disfagia).",
      },
      {
        h: "Terapia",
        p: "Correzione dello stile di vita, terapia con inibitori di pompa protonica, eradicazione dell'Helicobacter pylori quando presente, procinetici in casi selezionati.",
      },
    ],
  },
  "fegato-grasso": {
    title: "Fegato grasso (steatosi epatica)",
    subtitle: "Diagnosi e gestione della steatosi",
    intro:
      "La steatosi epatica non alcolica (NAFLD/MASLD) è la più comune malattia del fegato nei paesi occidentali. Un'individuazione precoce permette di prevenire la progressione verso steatoepatite e fibrosi.",
    sections: [
      {
        h: "Fattori di rischio",
        p: "Sovrappeso, diabete di tipo 2, sindrome metabolica, dislipidemia, sedentarietà.",
      },
      {
        h: "Diagnosi",
        p: "Esami ematici (transaminasi, profilo metabolico), ecografia addominale, elastografia epatica per valutare la fibrosi.",
      },
      {
        h: "Terapia",
        p: "Modifiche dello stile di vita (dieta mediterranea, attività fisica, calo ponderale), controllo del diabete e delle dislipidemie, follow-up regolare.",
      },
    ],
  },
  pancreatite: {
    title: "Pancreatite",
    subtitle: "Diagnosi e gestione della malattia pancreatica",
    intro:
      "La pancreatite è un'infiammazione del pancreas che può manifestarsi in forma acuta o cronica. Richiede sempre una valutazione specialistica per una diagnosi accurata e un percorso di cura mirato.",
    sections: [
      {
        h: "Cause principali",
        p: "Calcolosi biliare, abuso di alcol, ipertrigliceridemia, farmaci, cause autoimmuni o genetiche.",
      },
      {
        h: "Diagnosi",
        p: "Esami ematici (amilasi, lipasi), ecografia, TC addominale con mezzo di contrasto, ecoendoscopia in casi selezionati.",
      },
      {
        h: "Gestione",
        p: "Trattamento della causa sottostante, supporto nutrizionale, terapia enzimatica sostitutiva nelle forme croniche, controlli periodici.",
      },
    ],
  },
  "calprotectina-elevata": {
    title: "Calprotectina fecale elevata",
    subtitle: "Cosa significa e come procedere",
    intro:
      "La calprotectina fecale è un marker molto sensibile di infiammazione intestinale. Un suo aumento richiede sempre una valutazione specialistica per individuarne la causa.",
    sections: [
      {
        h: "Significato",
        p: "Livelli elevati di calprotectina indicano infiammazione della mucosa intestinale, tipica delle malattie infiammatorie intestinali ma presente anche in infezioni e altre condizioni.",
      },
      {
        h: "Percorso diagnostico",
        p: "Valutazione clinica accurata, esami del sangue, ricerca di infezioni intestinali, colonscopia con biopsie per confermare o escludere una IBD.",
      },
      {
        h: "Follow-up",
        p: "In caso di malattia infiammatoria intestinale nota, la calprotectina è un ottimo indicatore di attività di malattia e risposta alla terapia.",
      },
    ],
  },
};

// Blog posts
export const BLOG_POSTS = [
  {
    slug: "pancia-gonfia-cosa-significa",
    title: "Ho sempre la pancia gonfia: cosa significa?",
    excerpt:
      "Il gonfiore addominale è uno dei sintomi più riferiti in ambulatorio. Non sempre è banale: capiamo insieme quando è il caso di approfondire.",
    date: "12 Dicembre 2025",
    readTime: "6 min",
    image:
      "https://images.pexels.com/photos/4506105/pexels-photo-4506105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    category: "Sintomi",
    content: [
      "Il gonfiore addominale è un disturbo estremamente comune. Nella maggior parte dei casi è legato a intolleranze alimentari, disbiosi intestinale o sindrome dell'intestino irritabile.",
      "Quando il gonfiore è persistente, associato a calo di peso, dolore intenso o sangue nelle feci, è importante rivolgersi allo specialista per escludere patologie più significative.",
      "Un percorso diagnostico ragionato include breath test, calprotectina fecale e, quando indicato, endoscopia digestiva.",
    ],
  },
  {
    slug: "reflusso-o-infarto",
    title: "Reflusso o infarto? Come riconoscere la differenza",
    excerpt:
      "Il dolore toracico da reflusso può essere confuso con un problema cardiaco. Ecco i segnali distintivi da conoscere.",
    date: "5 Dicembre 2025",
    readTime: "5 min",
    image:
      "https://images.pexels.com/photos/4225920/pexels-photo-4225920.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    category: "Reflusso",
    content: [
      "Il dolore retrosternale da reflusso gastroesofageo può essere molto intenso e mimare un attacco cardiaco.",
      "In generale, il dolore da reflusso è bruciante, insorge dopo i pasti o in posizione supina e migliora con gli antiacidi.",
      "In caso di dubbio, la valutazione cardiologica è prioritaria: la sicurezza viene sempre prima.",
    ],
  },
  {
    slug: "helicobacter-quando-curarlo",
    title: "Helicobacter pylori: quando è necessario curarlo?",
    excerpt:
      "Non tutti i portatori di H. pylori devono ricevere terapia. Vediamo quando l'eradicazione è veramente indicata.",
    date: "28 Novembre 2025",
    readTime: "7 min",
    image:
      "https://images.pexels.com/photos/8460381/pexels-photo-8460381.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    category: "Diagnostica",
    content: [
      "L'Helicobacter pylori è un batterio molto diffuso nella popolazione generale. Non tutti i portatori sviluppano sintomi o patologie.",
      "L'eradicazione è indicata in presenza di ulcera peptica, gastrite atrofica, linfoma MALT, familiarità per carcinoma gastrico o sintomi dispeptici persistenti.",
      "La terapia di eradicazione va scelta con attenzione, tenendo conto delle resistenze antibiotiche locali.",
    ],
  },
  {
    slug: "colonscopia-fa-davvero-male",
    title: "Colonscopia: fa davvero male?",
    excerpt:
      "Uno dei timori più frequenti dei pazienti. Vediamo la realtà dell'esame e come renderlo confortevole.",
    date: "20 Novembre 2025",
    readTime: "4 min",
    image:
      "https://images.pexels.com/photos/7089401/pexels-photo-7089401.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    category: "Endoscopia",
    content: [
      "La colonscopia moderna, eseguita in sedazione profonda, è un esame ben tollerato e sostanzialmente indolore.",
      "La preparazione intestinale è spesso il momento più impegnativo, ma è fondamentale per un esame di qualità.",
      "L'esame è l'unico strumento realmente efficace di prevenzione del tumore del colon-retto.",
    ],
  },
];
